import { render, staticRenderFns } from "./ShipDShipStatusWidget.vue?vue&type=template&id=3f21dc1a&scoped=true"
import script from "./ShipDShipStatusWidget.vue?vue&type=script&lang=js"
export * from "./ShipDShipStatusWidget.vue?vue&type=script&lang=js"
import style0 from "./ShipDShipStatusWidget.vue?vue&type=style&index=0&id=3f21dc1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f21dc1a",
  null
  
)

export default component.exports